import Button from "@components/Button";
import React from "react";

const ResultAlert = ({alertThumbnail, alertUrl, alertTitle, alertText, alertBtnText}) => (
    <div className="result-alert card">
        {alertThumbnail && (
            <figure className="result-alert__image">
                <img src={alertThumbnail} alt={alertTitle}/>
            </figure>
        )}
        <div className="result-alert__body">
            <h3 className="h2" dangerouslySetInnerHTML={{__html: alertTitle}}/>
            <p className="lead">{alertText}</p>
            <Button className="mt-2 mt-sm-6" url={alertUrl} target="_blank">
                {alertBtnText}
            </Button>
        </div>
    </div>
);

export default ResultAlert;
